import React, { useState, useEffect } from 'react'
import ApiActions from '../../actions/ApiActions';
import { ToastContainer, toast } from "react-toastify";
import FrappButton from "../utilities/FrappButton";
import LeadRoutingForm from '../common/LeadRoutingForm'
import Switch from "react-switch";
import moment from 'moment';
import FutworkButton from '../../uicomponents/button/Button';
import { InfoIcon } from '../../assets/images';

const dummyObject = {
    "transferCriteria": [{ "outcome": "" }],
    "attempts": 5,
    "targetProject": ""
}


const LeadRouting = (props) => {
    const [isLeadRoutingEnabled, setIsLeadRoutingEnabled] = useState(false)
    const [formData, setFormData] = useState({})
    const [projectsAssociatedWithBrand, setProjectsAssociatedWithBrand] = useState([])
    const [leadTransferArray, setLeadTransferArray] = useState([dummyObject])
    const [loading, setLoading] = useState(true)
    const [selectedOutcomes, setSelectedOutcomes] = useState([])
    const [selectedProject, setSelectedProject] = useState([])
    const [projectOptions, setProjectOptions] = useState([])
    const [options, setOptions] = useState([])
    const [targetProjectsMandatoryHeaders, setTargetProjectsMandatoryHeaders] = useState([])

    const arrangeSelectedOutcomes = (selectoutcomes) => {
        return selectoutcomes.flatMap(item => item.outcome);
    }

    const fetchDetails = async (id) => {
        try {
            let projectDetails = await ApiActions.getTeleProject(id)
            setFormData({ ...projectDetails })
            setOptions(projectDetails && projectDetails.outcomes && projectDetails.outcomes.length > 0 ?
                projectDetails.outcomes.map((outcome, idx) => {
                    // if (!['busy or improper response', 'redial', 'schedule call back', 'voicemail', 'not connected'].includes(outcome.title.toLowerCase()) && outcome.isFollowup === false) {
                        return {
                            id: idx, value: outcome.title, label: `${outcome.title}${outcome.allowed == 'none' ? ' (Turned off) ' : ''}`.trim(),
                            isDisabled: selectedOutcomes && arrangeSelectedOutcomes(selectedOutcomes).includes(outcome.title) ? true : false
                        }
                    // }
                }).filter(Boolean) // filter out undefined values
                :
                [])

            if (projectDetails.brand) {
                const projectsLinkedToBrand = await ApiActions.getActiveTeleProjectsWithBrands(JSON.stringify(moment().format("YYYY-MM-DD")), projectDetails.brand)
                if (projectsLinkedToBrand && projectsLinkedToBrand.length > 0) {
                    const formatProjectsLinkedToBrand = projectsLinkedToBrand.map(({ title, id, taskProps }) => {
                        const mandatoryHeaders = taskProps && taskProps.filter(item => item.optional == false).map(item => item.name)
                        setTargetProjectsMandatoryHeaders(prev => [...prev, {
                            id,
                            mandatoryHeaders,
                            title
                        }])
                        return {
                            id,
                            title
                        }
                    })
                    setProjectsAssociatedWithBrand(formatProjectsLinkedToBrand)
                }
            }

            if (projectDetails.leadTransferConfig) {
                const { leadTransferConfig: { isActive, transferOptions } } = projectDetails
                const tempProjects = transferOptions.map(item => item.targetProject)
                const tempOutcomes = transferOptions.map(item => item.transferCriteria.map(crit => crit.outcome)).flat()

                const tempOutcomesWithIds = transferOptions.map((item, idx) => {
                    let obj = {}
                    obj = {
                        id: idx,
                        outcome: item.transferCriteria.map(crit => crit.outcome).flat(),
                    }
                    return obj
                })
                setIsLeadRoutingEnabled(isActive);
                setLeadTransferArray(transferOptions);
                setSelectedProject(tempProjects);
                setSelectedOutcomes(tempOutcomesWithIds);
            }
        } catch (error) {
            console.error(error.response)
            toast.error('Error fetching project data')
        } finally {
            setLoading(false)
        }
    }

    const getSourceProjectManadatoryHeader = () => {
        return formData && formData.taskProps && formData.taskProps.filter(item => {
            if (item.optional == false) {
                return item.name
            }
        }).map(item => item.name)
    }

    useEffect(() => {
        let id = props.match.params.id
        fetchDetails(id)
    }, [])

    const addMore = () => {
        const dummy = {
            "transferCriteria": [{ "outcome": "" }],
            "attempts": 5,
            "targetProject": ""
        }
        let newLeadTransfer = [...leadTransferArray, dummy]
        setLeadTransferArray(newLeadTransfer)
    }

    const removeLeadTransfer = (index) => {
        let copyLeadTransferArray = [...leadTransferArray]
        const indexToRemoved = copyLeadTransferArray.findIndex((i, idx) => idx == index)
        const projectIdToRemove = copyLeadTransferArray[indexToRemoved].targetProject
        copyLeadTransferArray.splice(indexToRemoved, 1)
        setLeadTransferArray(copyLeadTransferArray)
        setSelectedOutcomes(selectedOutcomes.filter((_, idx) => idx !== index))
        setSelectedProject(selectedProject.filter((item) => item !== projectIdToRemove))
    }

    const handleChangeOfOutcomes = (e, idx) => {
        const tempList = Array.isArray(e) ? e.map(x => x.value) : []
        let tempSelectedOutcomes = selectedOutcomes.map((item) => {
            if (item && item.id == idx) {
                item.outcome = tempList
            }
            return item
        })

        if (tempSelectedOutcomes[idx] == undefined) {
            tempSelectedOutcomes.push({
                id: idx,
                outcome: tempList
            })
        }

        const temp = tempSelectedOutcomes[idx] ? tempSelectedOutcomes[idx].outcome : [...arrangeSelectedOutcomes(tempSelectedOutcomes), ...tempList]

        const updateOptions = options && options.length > 0 ?
            options.map(opt => {
                if (temp.includes(opt.value)) {
                    opt.isDisabled = true
                } else {
                    opt.isDisabled = false
                }
                return opt
            }) : []
        setSelectedOutcomes(tempSelectedOutcomes);
        setOptions(updateOptions)
    }

    const handleChangeOfTargetProject = (e) => {
        const temp = [...new Set([...selectedProject, e.value])]
        const updateOptions = projectOptions && projectOptions.length > 0 ?
            projectOptions.map(opt => {
                if (temp.includes(opt.value)) {
                    opt.isDisabled = true
                } else {
                    opt.isDisabled = false
                }
                return opt
            }) : []
        setProjectOptions(updateOptions)
    }

    const getFormData = (key, value, position) => {
        const findIndex = leadTransferArray.findIndex((item, idx) => idx == position)
        const temp = [...leadTransferArray]

        if (key == 'transferCriteria') {
            temp[findIndex][key] = value.map(item => {
                return {
                    outcome: item
                }
            })
            setLeadTransferArray(temp)
        }

        if (key == 'targetProject') {
            const projectId = temp[findIndex][key]
            const findProjectIndx = selectedProject && selectedProject.findIndex((item) => item == projectId)
            if (findProjectIndx == -1) {
                temp[findIndex][key] = value
                setSelectedProject([...selectedProject, value])
                setLeadTransferArray(temp)
            } else {
                let tempSelectedProject = [...selectedProject]
                tempSelectedProject[findProjectIndx] = value
                temp[findIndex][key] = value
                setSelectedProject(tempSelectedProject)
                setLeadTransferArray(temp)
            }
        }

        if (key == 'attempts') {
            temp[findIndex][key] = value
            setLeadTransferArray(temp)
        }
    }

    if (loading == false) {
        return (
            <div className='templates_wrapper'>
                <div className='template_container'>
                    <div className='template_form'>
                        <div className={'template-active-row'}>
                            <label>Enable Outcome-based Project Setup </label><Switch onChange={(e) => {
                                setIsLeadRoutingEnabled(e)
                            }}
                                checked={isLeadRoutingEnabled}
                            />
                        </div>
                        {
                            isLeadRoutingEnabled ? leadTransferArray &&
                                leadTransferArray.map((item, idx) => {
                                    const outcome_options = formData && formData.outcomes && formData.outcomes.length > 0 ?
                                        formData.outcomes.map((outcome, idx) => {
                                            // if (!['busy or improper response', 'redial', 'schedule call back', 'voicemail', 'not connected'].includes(outcome.title.toLowerCase()) && outcome.isFollowup === false) {
                                                return {
                                                    id: idx, value: outcome.title, label: `${outcome.title}${outcome.allowed == 'none' ? ' (Turned off) ' : ''}`.trim(),
                                                    isDisabled: selectedOutcomes && arrangeSelectedOutcomes(selectedOutcomes).includes(outcome.title) ? true : false
                                                }
                                            // }
                                        }).filter(Boolean) // filter out undefined values
                                        :
                                        []

                                    const project_options = projectsAssociatedWithBrand && projectsAssociatedWithBrand.length > 0 ? projectsAssociatedWithBrand.map(project => {
                                        return {
                                            id: project.id, value: project.id, label: `${project.title}`.trim(),
                                            isDisabled: selectedProject && selectedProject.includes(project.id) ? true : false
                                        }
                                    }) : []


                                    return (
                                        <div key={idx} className='auto-lead-tranfer-form'>
                                            <LeadRoutingForm
                                                projectData={formData}
                                                projectsAssociatedWithBrand={projectsAssociatedWithBrand}
                                                item={item}
                                                idx={idx}
                                                setLeadTransferArray={setLeadTransferArray}
                                                removeLeadTransfer={removeLeadTransfer}
                                                selectedProject={selectedProject}
                                                selectedOutcomes={selectedOutcomes}
                                                setSelectedOutcomes={setSelectedOutcomes}
                                                setSelectedProject={setSelectedProject}
                                                getFormData={getFormData}
                                                options={outcome_options}
                                                projectOptions={project_options}
                                                handleChangeOfTargetProject={handleChangeOfTargetProject}
                                                handleChangeOfOutcomes={handleChangeOfOutcomes}
                                            />

                                        </div>
                                    )
                                }) : null
                        }
                        <div className='user_note'>
                            <div className='info_icon'><img src={InfoIcon} />
                                <u><b>Note :</b></u>
                            </div>
                            <ul className={'list'}>
                                <li>
                                    <div className={'headnote'}><span>Ensure that the mandatory headers required for the lead schema are present in the current and the target projects.</span></div>
                                </li>
                                <li>
                                    <div className={'headnote'}><span>Ensure that the target projects have these two headers defined in the lead schema: <b>previous_disposition</b>, <b>previous_lead_id</b>. These headers can be optional</span></div>
                                </li>                            </ul>
                        </div>
                        {isLeadRoutingEnabled ? <div className='add-more-lead-transfer' onClick={() => addMore()}>+ ADD MORE</div> : null}

                        {<div className='save_template_wrapper'>
                            <FutworkButton buttonStyle="primary--solid" buttonSize="sm"
                                onClick={() => {
                                    if (leadTransferArray && leadTransferArray.length > 0) {
                                        const isValid = leadTransferArray.every(item => {
                                            return item.transferCriteria && item.transferCriteria.length > 0 && item.targetProject && item.attempts
                                        })
                                        const checkAttemptRange = leadTransferArray.every(item => {
                                            return item.attempts >= 1 && item.attempts <= 15
                                        })

                                        if (!isValid) {
                                            toast.error('Please fill all the fields')
                                            return
                                        }
                                        if (!checkAttemptRange) {
                                            toast.error('Attempts should be between 1 and 15')
                                            return
                                        }

                                        const  result = targetProjectsMandatoryHeaders.map(obj => {
                                            const missing = getSourceProjectManadatoryHeader().filter(header => obj.mandatoryHeaders && !obj.mandatoryHeaders.includes(header))
                                            return {
                                                id: obj.id,
                                                hasAll: missing.length === 0,
                                                missing
                                            };
                                        })
                                    } else {
                                        toast.error('Please add at least one transfer criteria')
                                        return
                                    }

                                    const payload = {
                                        "leadTransferConfig": {
                                            "transferOptions": leadTransferArray,
                                            "isActive": isLeadRoutingEnabled
                                        },
                                        "sourceProjectId": props.match.params.id
                                    }

                                    ApiActions.addLeadRoutingConfig(payload).then(resp => {
                                        toast.success('Lead routing configuration saved successfully')
                                        // props.history.push(`/projects`)
                                    }).catch(err => {
                                        const { response: { data } } = err
                                        console.error(data)
                                        const msg = data && data.error
                                        toast.error(msg || 'Error saving lead routing configuration')
                                    })
                                }
                                }
                            >SAVE</FutworkButton>
                        </div>}
                    </div>
                </div>

                <div className="btn-wrapper">
                    <FrappButton type="submit" className="submit"
                        handler={() => props.history.push({
                            pathname: `/projects`,
                        })}
                    >Finish</FrappButton>
                    <FrappButton className="submit" id="new-btn-2"
                        handler={() => props.history.push({
                            pathname: `/projects`,
                        })}
                    > Skip</FrappButton>
                </div>

                <ToastContainer draggable={true} />
            </div>
        )
    } else {
        return (
            <div className="loader-main" id="loader-size">
                <img src={require("../../assets/images/loadernew.gif")} />
                <div className="text">
                    We'll be right back. Here: listen to some awesome songs meanwhile
                    <a href="https://open.spotify.com/playlist/37i9dQZF1DX3rxVfibe1L0" target="_blank" rel="noopener noreferrer"> Take me</a>
                </div>
            </div>
        )
    }
}

export default LeadRouting